/**
 * TanStack Query hook — Comparison foundation (Chunk 9.Q.1).
 *
 * `GET /v1/projects/:id/comparison[?quote_request_id=]` — matrice brute read-only
 * des `extracted_fields` cross-submissions d'un projet. `api.get` unwrap `data`.
 */

import type { ComparisonResponse } from "@kollectivia/shared";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

export type ComparisonParams = {
  projectId: string | undefined;
  quoteRequestId?: string;
};

function buildPath(params: ComparisonParams): string {
  const base = `/v1/projects/${params.projectId}/comparison`;
  if (params.quoteRequestId) {
    return `${base}?quote_request_id=${encodeURIComponent(params.quoteRequestId)}`;
  }
  return base;
}

export function useProjectComparison(params: ComparisonParams) {
  return useQuery({
    queryKey: ["comparison", params.projectId, params.quoteRequestId ?? null],
    queryFn: () => api.get<ComparisonResponse>(buildPath(params)),
    enabled: !!params.projectId,
  });
}
